import { render, staticRenderFns } from "./MallSettings.vue?vue&type=template&id=06ef7276&scoped=true"
import script from "./MallSettings.vue?vue&type=script&lang=js"
export * from "./MallSettings.vue?vue&type=script&lang=js"
import style0 from "./MallSettings.vue?vue&type=style&index=0&id=06ef7276&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ef7276",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ef7276')) {
      api.createRecord('06ef7276', component.options)
    } else {
      api.reload('06ef7276', component.options)
    }
    module.hot.accept("./MallSettings.vue?vue&type=template&id=06ef7276&scoped=true", function () {
      api.rerender('06ef7276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/operationsManagement/Component/MallSettings.vue"
export default component.exports